import { useAuthentication } from 'src/features/authentication/context';
import { LoginLayout } from 'src/layouts';
import { OtpChallengePage } from '../../pages';
import { LoadingElement } from '../LoadingElement';

export const OtpChallengeElement = () => {
  const { loggedIn } = useAuthentication();

  if (!loggedIn.loaded) {
    return <LoadingElement />;
  }

  return (
    <LoginLayout>
      <OtpChallengePage />
    </LoginLayout>
  );
};
